import React from 'react';
import ReactDom from 'react-dom';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { SiteConfigManager, useUserMessages } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { clientProfileRoutes } from '@atlas/routing/build/routes/accountRoutes';
import { EmptyStateView, Icon, Label, Loader, Message } from '@atlas/ui';

import { defaultRoutes } from 'components/MainRouter/constants';

import ShortFooter from '../Footer/ShortFooter';

const { account } = defaultRoutes;
const { messages: messagesPath } = clientProfileRoutes;
const { CLIENT_PROFILE } = COMPONENT_TYPES;

const MessagesList = () => {
  const { currentPage, hasMore, isLoading, loadMore, messages } = useUserMessages();

  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);

  const [sentryRef, { rootRef }] = useInfiniteScroll({
    hasNextPage: hasMore,
    loading: isLoading,
    onLoadMore: loadMore,
  });

  return ReactDom.createPortal(
    <div className="profile-wrapper-absolute">
      <Link className="back-to-container" to={account}>
        <Icon className="icon-back" name="back" />
        <Label className="title-text" message="messages" />
      </Link>

      {messages.length !== 0 && (
        <Label className="messages-header" message="messages_select_your_message" />
      )}

      <div className={cx('messages-list', messages.length === 0 && 'messages-empty')} ref={rootRef}>
        <div className="messages-list-content">
          {messages.length === 0 && currentPage !== 0 ? (
            <EmptyStateView
              className="relative with-bg"
              description="messages_empty_message"
              title="messages_empty_title"
            />
          ) : (
            messages.map(({ createTime, id, messageBody, read, subject }, index) => (
              <Link
                className="message-link"
                key={id}
                to={`${clientProfilePath}/${messagesPath}/${id}`}
              >
                <Message
                  className="message-element"
                  createTime={createTime}
                  isExpanded={index === 0}
                  read={read}
                  subject={subject}
                >
                  {messageBody}
                </Message>
              </Link>
            ))
          )}
          {hasMore && (
            <div className="message-element placeholder" ref={sentryRef}>
              {isLoading && <Loader />}
            </div>
          )}
        </div>
        <ShortFooter />
      </div>
    </div>,
    document.body,
  );
};

export default MessagesList;
